import React, {Component, Fragment} from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen, faXmark, faEye} from '@fortawesome/free-solid-svg-icons';
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
class CurriculumsAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            cvdatas: [],
            confirmdeletecv: false,
            showModalId: null
        };
    }

    handleShow = (id) => {
        this.setState({ confirmdeletecv: true });
        this.setState({ showModalId: id });
    }

    handleClose = () => {
        this.setState({ confirmdeletecv: false });
        this.setState({ showModalId: null });
    }
     mytoken = JSON.parse(localStorage.getItem('token')).token;
     config = {
        headers: { Authorization: `Bearer ${this.mytoken}` }
    };
     setRedirection(id){
         window.location.replace('/admin/curriculum/'+id);
     }
    setSwitch(id){}

    getcvs(){
        axios.get(`https://api.nvdxavier.com/api/curriculums`,this.config )
            .then(res => {
                this.setState({cvdatas : res.data });
            })
            .catch(err => console.error(err));
    }
    deleteCv(id){
        axios.delete(`https://api.nvdxavier.com/api/curriculum/`+id,this.config )
             .then(res => {
                 res.status === 200 ? this.getcvs() : console.log(res.status);
             })
             .catch(err => console.error(err));
        this.setState({ confirmdeletecv: false });
        this.setState({ showModalId: null });
    }
    componentDidMount() {
        this.getcvs();
    }

    render(){
        const {
            cvdatas
        } = this.state;
            return (
                <Fragment>
                    <section id="signup" className="signup-section">
                        <div className="container">
                            <div className="align-self-center">
                                <Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>mise en avant</th>
                                        <th>id</th>
                                        <th>titre</th>
                                        <th>cv</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {cvdatas.map((info, key) => (

                                        <tr key={info.id}>
                                            <th>{String(info.ontop)}</th>
                                            <th>{info.id}</th>
                                            <th>{info.firstname}&nbsp;{info.lastname}</th>
                                            <th><small>{info.title}</small></th>
                                            <th>
                                                <ButtonGroup aria-label="Basic example">
                                                    <Button variant="warning" onClick={() => this.setRedirection(info.id)}>
                                                        <FontAwesomeIcon icon={faPen}></FontAwesomeIcon>
                                                    </Button>
                                                    <Button variant="outline-warning" onClick={() => this.setSwitch(info.id)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </Button>
                                                    <Button variant="outline-danger" onClick={() => this.handleShow(info.id)}>
                                                        <FontAwesomeIcon icon={faXmark} />
                                                    </Button>
                                                </ButtonGroup>
                                                <Modal
                                                    show={this.state.showModalId === info.id}
                                                    onHide={this.handleClose}
                                                    className="modal-lg"
                                                >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Supprimer le CV n°&nbsp;{info.id}&nbsp;{info.title} ?</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Button variant="secondary" onClick={this.handleClose}>
                                                            Abandonner
                                                        </Button>
                                                        <Button variant="danger" onClick={() => this.deleteCv(info.id)}>
                                                            Supprimer
                                                        </Button>
                                                    </Modal.Body>
                                                </Modal>
                                            </th>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </section>
                </Fragment>
            );
        }
}
export default CurriculumsAdmin;
